<ui-input-wrapper
    #wrapper
    [label]="label()"
    [value]="value()"
    [focussed]="focussed()"
    [error]="error()"
    [errorMsg]="errorMsg()"
    [inputId]="inputId"
>
    <input
        class="flex h-full w-full items-center px-16 text-transparent transition-all outline-none"
        [ngClass]="{
            '!text-black': value() || focussed() || !label(),
        }"
        [type]="type()"
        [value]="value() ?? null"
        [placeholder]="placeholder()"
        [attr.aria-describedby]="error() && errorMsg() ? wrapper.errorId : null"
        [id]="inputId"
        [attr.aria-invalid]="error()"
        (input)="setValue($event)"
        (focus)="_onTouch?.(); focussed.set(true)"
        (blur)="focussed.set(false)"
    />
</ui-input-wrapper>
